export default __webpack_public_path__ + "img/7adaac048872904db2a600939afd91a1.png";